import { useNavigate } from 'react-router-dom';
import { Icon as CroplerIcon, Button } from '@cropler/ui-kit';

import styles from './styles.module.scss';
import { useViewport } from '../../hooks';
import { BreakpointMobileUp } from '../../constants/ui';

const AuthTitle = ({ withBackButton = false, withBackButtonOnlyMobile = false, title }) => {
  const navigate = useNavigate();
  const { widthViewport } = useViewport();
  return (
    <div className={styles.titleContainer}>
      {(withBackButton || (withBackButtonOnlyMobile && widthViewport < BreakpointMobileUp)) && (
        <Button type="text" className={styles.backButton} onClick={() => navigate(-1)}>
          <CroplerIcon name="left" />
        </Button>
      )}
      <h1 className={styles.title}>{title}</h1>
    </div>
  );
};

export default AuthTitle;
